import React,{useContext,useState,useEffect} from 'react'
import { CommonModal } from '../../../AbstractElements'
import {
    Label,
    Form,
    FormGroup,
    Row,
    Col,
} from "reactstrap";
import Select from "react-select";
import { showAlert } from '../../../Services/Shared.service';
import SharedDataContext from '../../../_helper/SharedData';
import { updateDriverScheme,getDriverSchemeById } from '../../../Services/Driver.service';
import { useForm } from 'react-hook-form';
import CustomizerContext from '../../../_helper/Customizer';


function DriverSchemeEdit({editId,isModal,closeModal,triggerRefresh}) {

    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset,
        watch
      } = useForm({
        defaultValues: {},
      });

  const { ServiceCity } = watch()
  const {mix_background_layout} = useContext(CustomizerContext)
  const {cityData} = useContext(SharedDataContext)
  const [selectedScheme,setSelectedScheme] = useState({})
  
  useEffect(()=>{
   if(editId){
    getDriverSchemeById(editId).then((resp)=>{
      setSelectedScheme(resp.data)
          reset({
                name:resp?resp.data.name:"",
                ServiceCity:cityData.find(element =>element.id === resp.data.serviceCityId),
                isSubscription:resp?resp.data.isSubscription:false,
                isHide:resp?resp.data.isHide:false
          })
        })
   }
  },[editId])


  const handleSchemeSubmit = (formValues) => {

    const body ={
      name:formValues?formValues.name:"",
      serviceCityId:formValues?formValues.ServiceCity.id:"",
      isSubscription:formValues?formValues.IsSubscription:false,
      isHide:formValues?formValues.IsHide:false,
      createdOn:selectedScheme.createdOn,
      createdById:selectedScheme.createdById,
      deletedOn:selectedScheme.deletedOn,
      deletedById:selectedScheme.deletedById
    }

    if(editId !== null){
      body["id"] = editId;
      updateDriverScheme(body).then((resp)=>{
        closeModal()
        showAlert("success","Updated Successfully")
        triggerRefresh()
      }).catch((err)=>{
        showAlert("error","Something went wrong")
      })

    // console.log("DriverScheme",formValues)
  }}

  return (
    <CommonModal
    isOpen={isModal}
    title={"Edit Driver Configurations"}
    toggler={() => {
      closeModal()
    }}
    size="xl"
    >
        <Form onSubmit={handleSubmit(handleSchemeSubmit)}>
            <Row>
              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Name</Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("name", {
                      required: {
                        value: true,
                        message: "Name is required",
                      },
                      onChange: (e) => {
                        setValue("name", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.name?.message}
                  </span>
                </Col>
              </FormGroup>
              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Service City</Label>
                <Col lg="12">
                  <Select
                  value={ServiceCity?ServiceCity:{ label: "Select Service City", value: "" }}
                    options={cityData}
                    {...register("ServiceCity", {
                      required: {
                        value: true,
                        message: "Service City Required",
                      },
                    })}
                    onChange={(e) => {
                      setValue("ServiceCity", e);
                    }}
                    isDisabled
                    placeholder={"Select Service City"}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.ServiceCity?.message}
                  </span>
                </Col>
              </FormGroup>
            <FormGroup
            className="col-lg-2"
            style={{ display: "flex", alignItems: "center" }}
            >
            <div
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
              style={{ display: "flex", alignItems: "center",}}
            >
              <input
              style={{
                width:"1.5rem",
                height:"1.5rem"
              }}
                id="isSubscription"
                type="checkbox"
                {...register("IsSubscription",{
                })}
              />
              <Label className ="mb-0" for="isSubscription">
                {"IsSubscription"}
              </Label>
            </div>
          </FormGroup>

          <FormGroup
            className="col-lg-2"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
              style={{ display: "flex", alignItems: "center",}}
            >

              <input
              style={{
                width:"1.5rem",
                height:"1.5rem"
              }}
                id="isHide"
                type="checkbox"
                {...register("IsHide",{
                })}
              />

              <Label className ="mb-0" for="isHide">
                {"IsHide"}
              </Label>
            </div>
          </FormGroup>

        </Row>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3rem",
            }}
          >
            <button type="submit" className="btn submit-button" >
              {"Update"}
            </button>
          </div>
        </Form>
    </CommonModal>
  )
}

export default DriverSchemeEdit;